export const MAGIC_LINK_ERROR_PARAM = "error";

/**
 * better-auth's magic-link verify endpoint redirects to the errorCallbackURL
 * with `?error=<code>` on failure. The codes are plain string literals inside
 * better-auth (nothing is exported for them), so the ones we care about are
 * mirrored here:
 *   - EXPIRED_TOKEN: the link was clicked past its expiry window.
 *   - INVALID_TOKEN: the token no longer exists — already used, or expired
 *     and cleaned up. Users commonly hit this by re-clicking an old email.
 * Other codes (failed_to_create_session, ...) get a generic message.
 */
export function getMagicLinkErrorMessage(
  params: URLSearchParams,
): string | null {
  const code = params.get(MAGIC_LINK_ERROR_PARAM);
  if (!code) {
    return null;
  }
  if (code === "EXPIRED_TOKEN") {
    return "This login link has expired — links only work for 24 hours.";
  }
  if (code === "INVALID_TOKEN") {
    return "It looks like you clicked an old login link. If you have several login emails, only the newest one works.";
  }
  return "We couldn't log you in with that link.";
}
